import {routePreparationCounts} from "./triproutes-route-outcomes.mjs";
import { moneyLabel } from "./helpers.mjs";
const agents = {
  "triproutes-route-checks":"Jev · Проверка маршрутов",
 "triproutes-route-analysis":"Jev · Анализ маршрутов",
 "triproutes-city-checks":"Jev · Проверка городов",
  "triproutes-route-ideas": "Агент 1 · Идеи маршрутов",
  "triproutes-media-research": "Агент 2 · Исследование мест",
  "triproutes-route-assembly": "Агент 3 · Сборка маршрутов",
  "triproutes-route-fact-check": "Агент 4 · Проверка фактов",
  "triproutes-city-content": "Карточка города",
  "triproutes-bestplaces": "Места",
};
const stages = {
  bp0_discovery: "BP0 · Поиск мест", bp0_resolve: "Проверка места", bp1_content: "BP1 · Факты", bp2_media: "BP2 · Фотографии", bp3_synthesis: "BP3 · Карточка места", bp4_verify: "BP4 · Проверка", bestplace_import: "Сохранение места", route_launch: "Запуск маршрутов", city_check: "Проверка города", city_cover: "Обложка города",
  route_sources: "Агент 0 · Исследователь города", city_research: "Агент 0 · Исследователь города",
  ideas: agents["triproutes-route-ideas"], media_search: agents["triproutes-media-research"],
  assemble: agents["triproutes-route-assembly"], fact_check: agents["triproutes-route-fact-check"],
  import: "Сохранение черновиков", c1_content: "Карточка города · Исследование",
  c2_media: "Карточка города · Фото", c3_synthesis: "Карточка города · Текст",
  c4_verify: "Карточка города · Проверка", city_import: "Сохранение карточки города",
};
export function triproutesAgentLabel(run = {}) {
  return stages[run.externalStageRef] || agents[run.agentVersionRef?.id] || run.externalStageRef || run.agentVersionRef?.id || "Агент";
}
export function triproutesStageLabel(stage) { return stages[stage] || stage || "Этап"; }
export function triproutesModelCombination(models = []) {
  return [...new Set(models.flatMap((snapshot) => Object.entries(snapshot.roles || {})
    .filter(([role]) => !["route_sources", "city_research"].includes(snapshot.stage) || role === "route_sources")
    .map(([, binding]) => `${binding.provider}: ${binding.model}`)))].sort().join(" + ");
}
export function triproutesSuccessRate(job = {}) {
  if (job.domainUnavailable || !(job.requestedRouteCount > 0) || job.moderationRouteCount == null) return "—";
  return `${new Intl.NumberFormat("ru-RU", { maximumFractionDigits: 1 }).format(100 * job.moderationRouteCount / job.requestedRouteCount)}%`;
}
export function triproutesPhotoCoverage(item = {}) {
  const targets = item.mediaTargetCount;
  const covered = item.mediaCoveredTargetCount;
  if (!Number.isInteger(targets) || !Number.isInteger(covered) || targets < 0 || covered < 0 || covered > targets) {
    return { value: "Нет данных", note: "Показатели поиска фото недоступны" };
  }
  if (targets === 0) return { value: "—", note: "Объекты для поиска фото не подготовлены" };
  return { value: `${covered} / ${targets}`, note: `Без фото: ${targets - covered}`, targets, covered };
}
export function triproutesJobCost(job = {}) {
  if (job.accountingUnavailable) return { value: "Недоступно", note: "Учёт Harness временно недоступен" };
  const cost = job.cost;
  // Use accepted historical costs only when no live physical attempts exist.
  // Archive and live amounts may overlap and cannot be added automatically.
  if (!(cost?.attemptCount > 0) && job.archive) {
    const history = job.archive;
    const currencies = Object.entries(history.knownAmounts || {}).filter(([, amount]) => amount != null);
    if (currencies.length > 1) return { value: "Разные валюты", note: "Сохранённые расходы — в истории запуска" };
    if (currencies.length === 1 && currencies[0][0] !== "USD" && currencies[0][0] !== "unknown") return { amount: currencies[0][1], currency: currencies[0][0], coverage: history.unknownCosts > 0 ? "partial" : "complete", note: "Сохранённые расходы из принятой истории" };
    if (history.knownUsd == null) return { value: "Нет данных", note: "Стоимость в принятой истории неизвестна" };
    return { amount: history.knownUsd, currency: "USD", coverage: history.unknownCosts > 0 ? "partial" : "complete", note: "Сохранённые расходы из принятой истории" };
  }
  if (cost?.coverage === "none" && cost.attemptCount > 0) return { value: "Не рассчитано", note: "Стоимость зарегистрированных вызовов неизвестна" };
  if (!cost || cost.coverage === "none") return { value: "Нет данных", note: "Расходы пока не зарегистрированы" };
  if (cost.currency === "MIXED") return { value: "Разные валюты", note: "Суммы доступны в деталях вызовов" };
  return { amount: cost.providerCost, currency: cost.currency, coverage: cost.coverage };
}
export function triproutesCostWarning(usage, missingCosts = []) {
  const missing = usage?.unknownCostCount;
  if (!(missing > 0) && !missingCosts.length && usage?.coverage !== "partial") return "";
  const labels = [...new Set(missingCosts.map((call) => {
    const agent = call.agentId || call.stage ? triproutesAgentLabel({ agentVersionRef: { id: call.agentId }, externalStageRef: call.stage }) : "";
    const model = [call.provider, call.model].filter(Boolean).join(": ");
    const label = [agent, model].filter(Boolean).join(" — ");
    const reason = triproutesCostReasonLabel(call.reason || call.costReason);
    return reason ? `${label} (${reason})` : label;
  }).filter(Boolean))].sort();
  return labels.length ? `Стоимость неполная. Не рассчитано: ${labels.join("; ")}.` : "Стоимость неполная: стоимость части вызовов не рассчитана. Подробности — в этапах и ошибках.";
}
export function triproutesUnpricedAttempts(attempts = []) {
  return attempts.filter((attempt) => !["final", "reconciled"].includes(attempt.costStatus) || attempt.providerCost == null || attempt.providerCost === "" || !attempt.currency);
}
export function triproutesAttemptCostLabel(attempt = {}) {
  const reason = triproutesCostReasonLabel(attempt.costReason);
  if (reason) return reason;
  if (attempt.costStatus === "partial" && attempt.actualUsage?.some((measure) => measure.metric === "unclassified_paid_usage" && measure.quantity > 0)) {
    return "Провайдер вернул нераспознанные данные о расходах; полная стоимость неизвестна.";
  }
  return ({ final: "Рассчитано по использованию и тарифу", reconciled: "Сверено с провайдером", priced: "Рассчитано", partial: "Данные об использовании или тариф не позволяют рассчитать полную стоимость", unknown: "Стоимость неизвестна: нет тарифа или данных об использовании", unpriced: "Нет тарифа", preliminary: "Предварительная стоимость" })[attempt.costStatus] || attempt.costStatus || "Стоимость неизвестна";
}
export function triproutesCostReasonLabel(reason) {
  return ({
    in_progress: "вызов ещё выполняется",
    missing_usage: "пригодные счётчики токенов не извлечены из ответа",
    response_timeout: "истекло время ожидания ответа; пригодные счётчики токенов не извлечены",
    deadline_exceeded: "истёк общий срок запроса; пригодные счётчики токенов не извлечены",
    network_timeout: "таймаут соединения; пригодные счётчики токенов не извлечены",
    client_canceled: "запрос отменён; пригодные счётчики токенов не извлечены",
    connection_reset: "соединение сброшено; пригодные счётчики токенов не извлечены",
    broken_pipe: "соединение закрыто при передаче; пригодные счётчики токенов не извлечены",
    unexpected_eof: "ответ оборвался; пригодные счётчики токенов не извлечены",
    network_error: "ошибка соединения; пригодные счётчики токенов не извлечены",
    response_error: "ошибка получения ответа; пригодные счётчики токенов не извлечены",
    invalid_json: "не удалось разобрать JSON ответа и извлечь счётчики токенов",
    invalid_stream: "не удалось разобрать поток ответа и извлечь счётчики токенов",
    response_too_large: "ответ превысил лимит размера; пригодные счётчики токенов не извлечены",
    settlement_pending: "счётчики сохранены; расчёт стоимости ещё не завершён",
    ledger_write_failed: "сбой записи учёта; требуется восстановление расчёта",
    accounting_interrupted: "учёт вызова не завершён после остановки этапа; требуется проверка",
    provider_http_error: "провайдер вернул HTTP-ошибку; пригодные счётчики токенов не извлечены",
    provider_aborted: "провайдер прервал генерацию; пригодные счётчики токенов не извлечены",
    missing_tariff: "нет тарифа для модели",
    unclassified_usage: "счётчики получены, но формат расхода не распознан полностью",
    incomplete_tariff: "тариф не покрывает все категории расхода",
  })[reason] || "";
}
export function triproutesAttemptDiagnostics(attempt = {}) {
  const d = attempt.diagnostics;
  if (!d) return [];
  const phases = { dispatch: "Отправка запроса", response_status: "HTTP-статус", generation: "Генерация", response_read: "Чтение ответа", response_parse: "Разбор ответа", response_assembly: "Сборка ответа", settlement: "Запись учёта", checkpoint: "Сохранение счётчиков" };
  const errors = { provider_http_error: "Провайдер вернул HTTP-ошибку", provider_aborted: "Провайдер прервал генерацию", unexpected_eof: "Ответ оборвался", connection_reset: "Соединение сброшено", broken_pipe: "Соединение закрыто при передаче", deadline_exceeded: "Истёк общий срок запроса", network_timeout: "Таймаут соединения", client_canceled: "Запрос отменён", invalid_json: "Некорректный JSON", invalid_stream: "Некорректный поток", response_too_large: "Превышен размер ответа", network_error: "Ошибка соединения", response_error: "Ошибка получения ответа", ledger_write_failed: "Сбой записи учёта" };
  return [
    d.httpStatus && `HTTP: ${d.httpStatus}`,
    d.phase && `Этап: ${phases[d.phase] || d.phase}`,
    d.error && `Причина: ${errors[d.error] || d.error}`,
    d.ledgerError && `Учёт: ${errors[d.ledgerError] || d.ledgerError}`,
    d.finishReason && `Завершение генерации: ${d.finishReason}`,
    d.checkpointFailures > 0 && `Сбои сохранения счётчиков: ${d.checkpointFailures}`,
    `Ответ завершён: ${d.responseComplete ? "да" : "нет"}`,
    `Счётчики: ${d.usageState === "received" ? "извлечены" : "не извлечены"}`,
    d.receivedBytes != null && `Получено байт: ${d.receivedBytes}; служебных keep-alive: ${d.keepAliveBytes || 0}`,
    d.payloadBytes != null && `Данные JSON/SSE: ${d.payloadBytes} байт`,
    d.whitespaceBytes > 0 && `Пробелы и пустые строки по краям JSON: ${d.whitespaceBytes} байт`,
    attempt.providerRequestRef && `ID запроса: ${attempt.providerRequestRef}`,
    d.completionId && `ID ответа: ${d.completionId}`,
  ].filter(Boolean);
}
const reasons = {
  import_duplicate_route: "Маршрут отклонён при импорте как дубликат существующего маршрута. На модерацию не передан.",
  import_fact_check_rejected: "Маршрут отклонён проверкой фактов и не передан на модерацию.",
  task_budget_exceeded: "Запрос не отправлен: требуемый резерв превышает доступный бюджет задания.",
  task_budget_unavailable: "Запрос не отправлен: не удалось проверить тариф и резерв расходов.",
  organization_budget_exceeded: "Запрос не отправлен: недостаточно доступного баланса организации.",
  beta_budget_exceeded: "Запрос не отправлен: достигнут предел расходов бесплатной беты.",
  beta_trial_expired: "Запрос не отправлен: срок бесплатной беты истёк.",
  geo_gate_visit_anchor_missing: "Не подтверждена точка посещения одной из остановок (вход или подход к объекту). Маршрут оставлен в черновиках для ручной проверки координат.",
  geo_gate_visit_anchor_invalid: "У точки посещения некорректные координаты. Требуется ручная проверка маршрута.",
  geo_gate_feature_geometry_missing: "Нет географических данных для проверки одной из остановок. Требуется ручная проверка маршрута.",
  geo_gate_feature_geometry_invalid: "Не удалось проверить географические данные одной из остановок. Требуется ручная проверка маршрута.",
  geo_gate_indeterminate: "Координаты остановок не удалось подтвердить. Требуется ручная проверка маршрута.",
  invalid_api_key: "Провайдер отклонил API-ключ. Проверьте ключ организации в «Списке моделей».",
  local_sources_unavailable: "Исследователь не смог получить источники для города.",
  media_research_failed: "Не удалось исследовать объекты и подобрать материалы.",
  media_coverage_low: "Недостаточно материалов и фотографий для объектов.",
  insufficient_pois: "Недостаточно подходящих объектов для сборки маршрутов.",
  rate_limit_exceeded: "Провайдер ограничил частоту запросов.",
  provider_timeout: "Провайдер не ответил за отведённое время.",
  timeout: "Истекло время выполнения.",
  triproutes_model_not_allowed: "Выбранная модель не разрешена для этого агента.",
};
export function triproutesErrorLabel(code) { return code ? reasons[code] || `Ошибка: ${code}` : ""; }
export function triproutesRunError(run = {}) {
  // Failed retries in a completed run belong in the attempts, not in its verdict.
  if (run.state !== "failed") return "";
  const failed = (run.stages || []).find((stage) => stage.state === "failed");
  return failed?.lastErrorCode || [...(failed?.attempts || [])].reverse().find((attempt) => attempt.errorCode)?.errorCode || "";
}
export function triproutesResultSummary(result) {
  if (!result || typeof result !== "object") return "Результат сохранён";
  const body = result.content && typeof result.content === "object" ? result.content : result;
  const parts = [];
  for (const [key, label] of [["ideas", "Идеи"], ["subjects", "Объекты"], ["sources", "Источники"], ["drafts", "Черновики"], ["routes", "Маршруты"], ["cityQueries", "Поисковые запросы"], ["findings", "Замечания"]]) {
    if (Array.isArray(body[key])) parts.push(`${label}: ${body[key].length}`);
  }
  if (result.verdict) parts.push(`Вердикт: ${result.verdict}`);
  if (result.noRoutesReason) parts.push(triproutesErrorLabel(result.noRoutesReason));
  return parts.join(" · ") || "Результат сохранён";
}
export function triproutesTotalCost(calls = []) {
  const measured = calls.map((run) => run.usage).filter(Boolean);
  const currencies = new Set(measured.filter((usage) => usage.providerCost != null && usage.providerCost !== "").map((usage) => usage.currency));
  if (currencies.size > 1) return { coverage: "mixedCurrencies" };
  const priced = measured.filter((usage) => usage.providerCost != null && usage.providerCost !== "");
  if (!priced.length) return { coverage: "none" };
  const decimals = priced.map((usage) => String(usage.providerCost));
  if (decimals.some((value) => !/^\d+(?:\.\d+)?$/.test(value))) return { coverage: "none" };
  const scale = Math.max(...decimals.map((value) => (value.split(".")[1] || "").length));
  const sum = decimals.reduce((total, value) => { const [whole, fraction = ""] = value.split("."); return total + BigInt(whole + fraction.padEnd(scale, "0")); }, 0n).toString().padStart(scale + 1, "0");
  const amount = scale ? `${sum.slice(0, -scale)}.${sum.slice(-scale)}`.replace(/\.?0+$/, "") : sum;
  return { amount, currency: priced[0].currency,
    coverage: measured.length === calls.length && measured.every((usage) => usage.coverage === "complete") ? "complete" : "partial" };
}

// A variant names the historical published configuration, never the current one.
export function triproutesVariantLabel(job = {}) {
  return job.variant > 0 ? `Вариант ${job.variant}` : "Базовая";
}
export function triproutesCompactCost(job = {}) {
  const recorded = triproutesJobCost(job);
  if (recorded.amount == null) return { value: recorded.value === "Разные валюты" ? recorded.value : "—", note: recorded.note || "Стоимость неизвестна" };
  return { value: moneyLabel(recorded.amount, recorded.currency).replace(/ USD$/, ""), note: `${recorded.coverage === "partial" ? "Стоимость неполная. " : ""}${recorded.note || "Подробности расходов — в деталях запуска"}` };
}

// Native draft processing is separate from technical Run completion. Missing
// queue counters from an older backend must never be interpreted as waiting.
export function triproutesDelivery(job={}) {
 const native=!job.domainUnavailable?job.routeDelivery:null;
 const formed=job.constructorRun?job.constructorCounters?.routes:job.draftCount;
 const assembled=native?Math.max(native.assembled||0,formed||0):formed;
 return {...(native||{}),assembled,known:!!native};
}
export function triproutesDeliveryText(job={}) {
 const d=triproutesDelivery(job);
 if(d.assembled==null||d.assembled===0)return '';
 const parts=[`Собрано: ${d.assembled}`];
 const preparation=routePreparationCounts(job);
 if(preparation.cover_missing)parts.push(`нет обложки: ${preparation.cover_missing}`);
 if(preparation.requires_review)parts.push(`требуют проверки: ${preparation.requires_review}`);
 if(preparation.duplicate)parts.push(`исключено как дубликаты до импорта: ${preparation.duplicate}`);
 if(d.known){
  parts.push(`ожидают обработки: ${d.pending}`,`в обработке: ${d.processing}`,`передано на модерацию: ${d.submitted}`,`отклонено: ${d.rejected}`);
  for(const [key,label] of [['failed','ошибки обработки'],['review','требуют проверки'],['cancelled','отменено']])if(d[key]>0)parts.push(`${label}: ${d[key]}`);
 }else{
  const submitted=!job.domainUnavailable?Math.max(job.submittedToModerationCount||0,job.moderationRouteCount||0,job.publishedRouteCount||0):0;
  parts.push(submitted>0?`передано на модерацию: ${submitted}`:'передача на модерацию не подтверждена','состояние обработки уточняется');
 }
 return parts.join(' · ');
}

// Run completion is technical. Product success requires delivery to TripRoutes.
export function triproutesResultState(job={}) {
 const terminal=['completed','completed_partial','partial','failed','timed_out','cancelled','no_routes','budget_exceeded','fact_check_review','import_review'].includes(job.status);
 const errors={failed:'Ошибка',timed_out:'Истекло время',cancelled:'Отменён',budget_exceeded:'Превышен бюджет'};
 if(!terminal)return {label:job.status==='queued'?'В очереди':'В работе',kind:'running'};
 const delivery=triproutesDelivery(job);
 const submitted=Math.max(delivery.submitted||0,job.submittedToModerationCount||0,job.moderationRouteCount||0,job.publishedRouteCount||0);
 if(!job.domainUnavailable&&submitted>0){
  if((job.publishedRouteCount||0)>0)return {label:job.requestedRouteCount>job.publishedRouteCount?'Частично опубликован':'Опубликован',kind:job.requestedRouteCount>job.publishedRouteCount?'warning':'completed'};
  const onModeration=(job.moderationRouteCount||0)>0;
  return {label:onModeration?(job.requestedRouteCount>submitted?'Частично на модерации':'На модерации'):'Передан на модерацию',kind:job.requestedRouteCount>submitted?'warning':'completed'};
 }
 const prepared=routePreparationCounts(job);
 if(prepared.cover_missing>0)return {label:'Нет обложки',kind:'warning'};
 if(prepared.requires_review>0&&!(delivery.pending>0||delivery.processing>0))return {label:'Требует проверки',kind:'warning'};
 if(prepared.duplicate>0&&!(delivery.pending>0||delivery.processing>0))return {label:'Отклонён как дубликат',kind:'warning'};
 if(!job.constructorRun&&!job.domainUnavailable&&job.lastErrorCode==='import_duplicate_route')return {label:'Отклонены как дубликаты',kind:'warning'};
 if(errors[job.status])return {label:errors[job.status],kind:'error'};
 if(job.domainUnavailable||job.moderationRouteCount==null)return {label:delivery.assembled>0?'Собраны, передача не подтверждена':'Результат не подтверждён',kind:'warning'};
 if(!delivery.known&&(job.nativeLastErrorCode||job.lastErrorCode)==='import_duplicate_route')return {label:'Отказ при импорте: дубликат',kind:'warning'};
 if(delivery.known){
  if(delivery.processing>0)return {label:'Маршруты обрабатываются',kind:'running'};
  if(delivery.pending>0)return {label:'Ожидает обработки',kind:'running'};
  if(delivery.failed>0)return {label:'Ошибка обработки маршрутов',kind:'error'};
  if(delivery.review>0)return {label:'Требуется проверка маршрутов',kind:'warning'};
  if(delivery.rejected>0)return {label:(job.nativeLastErrorCode||job.lastErrorCode)==='import_duplicate_route'?'Отклонены как дубликаты':'Маршруты отклонены',kind:'warning'};
  if(delivery.cancelled>0)return {label:'Обработка отменена',kind:'warning'};
 }
 if(delivery.assembled>0)return {label:delivery.known?'Собраны, не переданы':'Собраны, передача не подтверждена',kind:'warning'};
 if(['queued','ideas_running','retry','candidates_ready','assembly_running','assembly_retry','drafts_ready','fact_check_running','fact_check_ready','import_running'].includes(job.nativeStatus))return {label:'Обработка в TripRoutes',kind:'running'};
 return {label:'Без результата',kind:'error'};
}
